import React from "react";

type RocketSVGProps = {
  className?: string;
};

const RocketSVG: React.FC<RocketSVGProps> = ({ className }) => (
  <g className={className}>
    <path
      fill="#c5cbe6"
      d="M471.335,5.37C367.603-16.646,277.543,30.872,201.06,114.63
         C79.761,114.63,1.146,221.336,1.146,265.218h67.765l15.337,20.442c-2.884,5.368-5.73,10.767-8.546,16.218
         c-4.894,9.261-9.69,18.733-14.321,28.265l85.67,85.662c9.577-4.57,19.17-9.261,28.536-14.042c4.872-2.485,9.705-5.007,14.517-7.529
         l21.24,15.925v67.765c42.82,0,150.588-76.71,150.588-200.162C446.24,200.751,493.487,109.683,471.335,5.37z"
    />
    <path
      fill="#eef0f0"
      d="M175.588,401.764c-9.367,4.781-18.959,9.472-28.536,14.042l-85.662-85.662
         c4.631-9.532,9.419-18.997,14.313-28.28C172.229,115.157,304.002-30.138,471.335,5.37
         C506.852,172.704,363.853,306.027,175.588,401.764z"
    />
    <path
      fill="#ffffff"
      d="M201.112,114.577C157.811,161.99,118.853,221.013,84.248,285.66l0,0
         c-0.301,0.557-7.085,13.395-8.546,16.218c-4.894,9.261-9.683,18.733-14.313,28.265l42.195,42.195L470.658,5.25
         C363.83-17.135,273.839,34.938,201.112,114.577z"
    />
    <circle fill="#2879ff" cx="380.854" cy="95.881" r="60.235" />
    <path
      fill="#261a5b"
      d="M175.588,401.764c-9.367,4.781-18.959,9.472-28.536,14.042l-85.662-85.662
         c4.631-9.532,9.419-18.997,14.313-28.28L175.588,401.764z"
    />
    <path
      fill="#f4f4f4"
      d="M137.956,406.613c0,21.459-12.356,36.292-32.376,45.779c2.402-9.043,2.259-19.132,2.259-30.72
         c-33.965,42.827-63.405,45.47-90.541,45.176c0-39.145,17.385-68.307,45.176-90.353c-11.972,0-22.189-0.233-31.533,2.485
         c9.495-20.706,24.448-32.602,46.735-32.602L137.956,406.613z"
    />
    <path
      fill="#3d3072"
      d="M125.306,351.204l-21.308,21.308l-42.609-42.616c4.661-9.487,9.412-18.974,14.298-28.235
         L125.306,351.204z"
    />
    <path
      fill="#448aff"
      d="M422.801,53.039v0.075l-84.864,85.158c-23.499-23.56-23.65-61.658-0.158-85.225
         C361.278,29.555,400.212,29.555,422.801,53.039z"
    />
  </g>
);

export default RocketSVG;
